import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckMarkSimpleIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 13,
	viewBox: "0 0 19 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.521 1.55817L7.43575 11.3378C7.03453 11.7269 6.39231 11.7116 6.01007 11.3039L1.78955 6.802",
		stroke: "white",
		strokeWidth: 1.5,
		strokeLinecap: "square"
	})
});
export default SvgCheckMarkSimpleIcon;
